import { QAPair, RawTicket, Ticket } from './types';

/**
 * A helper function to validate the answers in a form.
 * It returns true if at least one answer is valid (not empty or 'N/A').
 */
const hasValidAnswers = (responses: QAPair[]): boolean => {
	if (!responses || responses.length === 0) {
		return false;
	}
	return responses.some(
		(res) => res.answer && res.answer.trim() !== '' && res.answer.trim().toUpperCase() !== 'N/A',
	);
};

export const processRawTicketsIntoTickets = (rawTickets: RawTicket[]): Ticket[] => {
	if (!rawTickets) {
		return [];
	}

	const processedTickets = rawTickets
		.filter((rawTicket) => hasValidAnswers(rawTicket.responses))
		.map((rawTicket) => {
			const responses = rawTicket.responses;
			const questions = responses.map((res) => res.question);

			let inProgressAt: number | null = null;
			let completedAt: number | null = null;

			if (rawTicket.status === 'IN_PROGRESS') {
				inProgressAt = rawTicket.updatedAt;
			} else if (rawTicket.status === 'COMPLETED') {
				completedAt = rawTicket.updatedAt;
			}

			const ticket: Ticket = {
				id: `${rawTicket.callSid}_${rawTicket.ticketId}`,
				callSid: rawTicket.callSid,
				ticketId: rawTicket.ticketId,
				status: rawTicket.status,
				note: rawTicket.note,
				responses,
				questions,
				callerPhone: rawTicket.callerNumber,
				callDate: rawTicket.createdAt,
				completedAt,
				inProgressAt,
				transcript: '',
				shareableLink: null,
				workflowId: rawTicket.workflowId,
				ticketTitle: rawTicket.ticketTitle,
			};
			return ticket;
		});

	return processedTickets;
};
